export function getSwitch() {
    const toggleSwitch = document.querySelector(
        '.theme-switch input[type="checkbox"]',
    );
    const currentTheme = localStorage.getItem("theme")
        ? localStorage.getItem("theme")
        : null;

    if (currentTheme) {
        document.documentElement.setAttribute("data-theme", currentTheme);

        if (currentTheme === "dark") {
            toggleSwitch.checked = true;
        }
    }
}

export function switchTheme() {
    var checkBox = document.getElementById("checkbox");
    if (checkBox.checked == true) {
        document.documentElement.setAttribute("data-theme", "dark");
        localStorage.setItem("theme", "dark"); //add this
    } else {
        document.documentElement.setAttribute("data-theme", "light");
        localStorage.setItem("theme", "light"); //add this
    }
}
